import { combineReducers } from 'redux';
import { profile } from './profile.reducer';

export default combineReducers({
	profile
});